import api from '@/api/proxyWeb/articles'
import apiMe from '@/api/proxyWeb/me'

export default {

    addFavorite({ commit }, articleVariation) {
        commit('addFavorite', articleVariation)
        apiMe.putFavorite(articleVariation.postId)
    },

    get({ commit, state }) {

        commit('setCurrentArticle', null)

        return new Promise(resolve => {

            api.get(state.currentId)
                .then(article => {
                    commit('setCurrentArticle', article)
                    resolve(article)
                })
            })
    },

    getAllFavorites({ commit }) {

        commit('setAllFavorites', null)

        return new Promise(resolve => {

            apiMe.getFavorites()
                .then(articleVariations => {
                    commit('setAllFavorites', articleVariations)
                    resolve(articleVariations)
                })
            })
    },

    removeFavorite({ commit }, articleVariation) {
        commit('removeFavorite', articleVariation)
        apiMe.deleteFavorite(articleVariation.postId)
    }

}